<template>

  <div>
     <component v-if="Object.keys(survey).length" v-bind:is="get_component" :survey="get_avg()" />
  </div>

</template>

<script>

export default{

  props: {survey: Object, design: String},

  data: function () {
    return {
      show_design: this.design
    }
  },

  methods: {

    get_avg: function () {

      var avg = this.get_avg_clean_avg;

      avg.all = 0
      avg.all_percent = 0
      avg.percent = {1: 0, 2: 0, 3: 0, 4: 0, 5: 0}

      for (var i = 0; i < Object.values(avg.votes).length; i++) {
        avg.all += Object.values(avg.votes)[i]
      }

      for (i = 0; i < Object.values(avg.votes).length; i++) {
        if (Object.values(avg.votes)[i] * 1 == 0) {
          avg.percent[ Object.keys(avg.votes)[i] ] = Object.values(avg.votes)[i] * 1
         }

        else {
          avg.percent[ Object.keys(avg.votes)[i] ] = ((Object.values(avg.votes)[i] * 1) / (avg.all * 1)) * 100
         }

      }

      for (i = 0; i < Object.values(this.survey.votes).length; i++) {
        avg.all_percent += (Object.keys(this.survey.votes)[i] * 1) * Object.values(this.survey.votes)[i] * 1
      }

      if (avg.all) { avg.all_percent = avg.all_percent / avg.all }

      avg.all_percent = Math.round(avg.all_percent * 100) / 100


      return avg
    },

    clean_avg_votes(votes) {

      var r = {
        1:0,
        2:0,
        3:0,
        4:0,
        5:0
      };

      Object.keys(votes).forEach(function(v){

        r[ Math.floor(v * 1) ] += votes[v];

      });

      return r;
    }

  },
  computed: {

    get_component: function () {
      const badges = this.$store.getters.badges
      return badges[this.design]
    },

    get_avg_clean_avg(){

      var avg = JSON.parse(JSON.stringify(this.survey));

      if (typeof avg.votes === 'undefined') {
        avg.votes = {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0
        }
      }
      else{
        avg.votes = this.clean_avg_votes( JSON.parse(JSON.stringify(avg.votes)) );
      }

      return avg;
    }
  }
}

</script>
